<template>
	<div class="page">
		<aside class="sidebar" id="sidebar">
			<div class="sidebar-header">
				<div class="logo">
					<div class="logo-icon">🚗</div>
					<span>DriveBot</span>
				</div>
			</div>
			<nav class="nav-menu">
				<a href="/dashboard" class="nav-item active">
					<span class="nav-icon">📊</span>
					<span>Dashboard</span>
				</a>
				<a href="/dashboard/proFile" class="nav-item">
					<span class="nav-icon">👤</span>
					<span>Profile</span>
				</a>
				<a href="/dashboard/subscripTion" class="nav-item">
					<span class="nav-icon">💳</span>
					<span>Subscription</span>
				</a>
				<a href="/dashboard/hisTory" class="nav-item">
					<span class="nav-icon">📄</span>
					<span>History</span>
				</a>
				<a href="/dashboard/contAct" class="nav-item">
					<span class="nav-icon">📧</span>
					<span>Contact Us</span>
				</a>
				<a href="/dashboard/LiveSlots" class="nav-item">
					<span class="nav-icon">🌐</span>
					<span>Radar</span>
				</a>
			</nav>
		</aside>

		<!-- Main Content -->
		<main class="main-content">
			<!-- Topbar -->
			<header class="topbar">
				<div class="topbar-left">
					<button class="menu-toggle" @click="toggleSidebar()">☰</button>
					<h1 class="page-title">User Dashboard</h1>
				</div>
				<div class="topbar-right">
					<div class="user-menu">
						<!-- <div class="user-avatar">JD</div> -->
						<div>
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link">
									<div style="font-weight: 500">Submission ID：{{ Userinfo.orderNo }}</div>
									<div style="font-size: 14px; color: #6b7280; text-align: right">Type: {{ Userinfo.serviceType }}</div>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 5px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; font-size: 18px">log out</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</div>
			</header>

			<div class="dashboard">
				<!-- ── BODY ─────────────────────────────────────────────────── -->
				<div class="body">
					<!-- LEFT PANEL -->
					<div class="panel-left">
						<!-- ── STATUS HERO ── -->
						<div class="status-hero" :class="'hero-' + orderStatus">
							<div class="hero-top">
								<div class="hero-status-row">
									<div class="hero-indicator" :class="'ind-' + orderStatus">
										<span v-if="orderStatus === 'Active'" class="spin-ring"></span>
										<span v-else class="ind-icon">
											<span v-if="orderStatus === 'Success'">✓</span>
											<span v-else-if="orderStatus === 'Error'">!</span>
											<span v-else-if="orderStatus === 'Pause'">⏸</span>
											<span v-else>×</span>
										</span>
									</div>
									<div>
										<div class="hero-label">Search Status</div>
										<div class="hero-status-text" :class="'txt-' + orderStatus">
											{{ orderStatus }}
										</div>
									</div>
								</div>
								<div class="hero-badge" :class="'badge-' + orderStatus">
									<span v-if="orderStatus === 'Active'">↑ Searching for slots</span>
									<span v-else-if="orderStatus === 'Success'">✓ Appointment Booked!</span>
									<span v-else-if="orderStatus === 'Error'">Fix required</span>
									<span v-else-if="orderStatus === 'Pause'">⏸ Paused</span>
									<span v-else>Cancelled</span>
								</div>
							</div>

							<!-- status body -->
							<div class="hero-body">
								<!-- ACTIVE -->
								<div v-if="orderStatus === 'Active'" class="hero-searching">
									<div class="search-pulse">
										<div class="pulse-ring r1"></div>
										<div class="pulse-ring r2"></div>
										<div class="pulse-ring r3"></div>
										<div class="pulse-core">📡</div>
									</div>
									<div class="search-text">
										<div class="search-title">Searching for Earlier Tests</div>
										<div class="search-sub">Our bot is running 24/7 for cancelled slots</div>
										<div class="search-range">{{ Userinfo.startTime }} — {{ Userinfo.endTime }}</div>
									</div>
								</div>

								<!-- SUCCESS -->
								<div v-if="orderStatus === 'Success'" class="hero-success-grid">
									<div class="sg-item">
										<div class="sg-label">Test Centre</div>
										<div class="sg-val">{{ Userinfo.testCenter }}</div>
									</div>
									<div class="sg-item">
										<div class="sg-label">Date & Time</div>
										<div class="sg-val">{{ Userinfo.appointmentTime }}</div>
									</div>
									<div class="sg-item">
										<div class="sg-label">Postcode</div>
										<div class="sg-val">{{ Userinfo.postCode }}</div>
									</div>
									<div class="sg-item">
										<div class="sg-label">Change Date</div>
										<div class="sg-val">{{ Userinfo.changeDate }}</div>
									</div>
								</div>

								<!-- ERROR -->
								<div v-if="orderStatus === 'Error'" class="hero-error-box">
									<div class="error-title">An error occurred during booking</div>
									<div class="error-desc">{{ Userinfo.errorInfo }}</div>
									<div class="error-hint">Fix the issue and re-save your information on Profile to restart.</div>
								</div>

								<!-- PAUSE -->
								<div v-if="orderStatus === 'Pause'" class="hero-paused">
									<div class="paused-icon">⏸</div>
									<div class="paused-title">Search Paused</div>
									<div class="paused-sub">Turn it on below to resume searching.</div>
								</div>

								<!-- CANCELLED -->
								<div v-if="orderStatus === 'Cancelled'" class="hero-cancelled">
									<div class="cancelled-title">Service Cancelled</div>
									<div class="cancelled-sub">Your information will be automatically deleted after 30 days.</div>
								</div>
							</div>

							<!-- action button -->
							<div class="hero-action" v-if="orderStatus === 'Active' || orderStatus === 'Pause'">
								<button class="action-btn" :class="orderStatus === 'Active' ? 'action-btn--pause' : 'action-btn--play'" @click="setupdateStatus()">
									<span v-if="orderStatus === 'Active'">⏸&nbsp; Pause Search</span>
									<span v-else><i class="el-icon-video-play"></i>&nbsp; Resume Search</span>
								</button>
							</div>
							<div class="hero-action" v-else>
								<button class="action-btn action-btn--disabled" disabled><i class="el-icon-video-play"></i>&nbsp; Start Search</button>
							</div>
						</div>

						<!-- ── ACTIVITY ── -->
						<div class="section">
							<div class="section-head">
								<div class="section-title">Recent Activity</div>
							</div>

							<div class="timeline">
								<div v-for="(item, index) in historyList" :key="index" class="tl-item">
									<!-- slots available -->
									<template v-if="item.notificationType === 'slots available'">
										<div class="tl-dot tl-blue"></div>
										<div class="tl-content">
											<div class="tl-title">New Slot — {{ item.region }}</div>
											<div class="tl-time">{{ item.beforeDate }} → {{ item.afterDate }}</div>
										</div>
									</template>

									<!-- success -->
									<template v-else-if="item.notificationType === 'success'">
										<div class="tl-dot tl-green"></div>
										<div class="tl-content">
											<template v-if="item.region">
												<div class="tl-title">Booking Status</div>
												<div class="tl-time">
													<span v-if="item.isregion == 1">
														<b>{{ item.region1 }}</b> {{ item.region2 }}
													</span>
													<span v-else-if="item.isregion == 2">
														{{ item.region1 }} <b>{{ item.region2 }}</b>
													</span>
													<span v-else>{{ item.region1 }}</span>
												</div>
											</template>
											<template v-else>
												<div class="tl-title">Test Booked — {{ item.testCenter }}</div>
												<div class="tl-time">{{ item.appointmentTime }}</div>
											</template>
										</div>
									</template>

									<!-- slots unavailable -->
									<template v-else-if="item.notificationType === 'slots unavailable'">
										<div class="tl-dot tl-amber"></div>
										<div class="tl-content">
											<div class="tl-title">Slot Taken — {{ item.region }}</div>
											<div class="tl-time">{{ item.beforeDate }} → {{ item.afterDate }}</div>
										</div>
									</template>

									<!-- error -->
									<template v-else-if="item.notificationType === 'error'">
										<div class="tl-dot tl-red"></div>
										<div class="tl-content">
											<div class="tl-title">Booking Error</div>
											<div class="tl-time">{{ item.errorInfo }}</div>
										</div>
									</template>
								</div>

								<div v-if="!historyList.length" class="tl-empty">No recent activity</div>
							</div>
						</div>
					</div>
					<!-- /panel-left -->

					<!-- RIGHT PANEL -->
					<div class="panel-right">
						<!-- ── INFO CARDS ── -->
						<div class="info-stack">
							<div class="info-card">
								<div class="info-card-icon ic-blue">📍</div>
								<div class="info-card-body">
									<div class="info-card-label">Selected Test Centres</div>
									<div class="info-card-val">{{ Userinfo.appointmentslist ? Userinfo.appointmentslist.length : 0 }}</div>
									<div class="info-card-sub">
										<span v-for="(item, i) in Userinfo.appointmentslist" :key="i"> {{ item }}<span v-if="i < Userinfo.appointmentslist.length - 1"> &amp; </span> </span>
									</div>
								</div>
							</div>

							<div class="info-card">
								<div class="info-card-icon ic-amber">📅</div>
								<div class="info-card-body">
									<div class="info-card-label">Desired Date Range</div>
									<div class="info-card-val" style="font-size: 18px">{{ Userinfo.startMonth }} — {{ Userinfo.endMonth }}</div>
									<div class="info-card-sub">{{ Userinfo.startTime }} → {{ Userinfo.endTime }}</div>
								</div>
							</div>

							<div class="info-card">
								<div class="info-card-icon ic-purple">⚡</div>
								<div class="info-card-body">
									<div class="info-card-label">Service Type</div>
									<div class="info-card-val" style="font-size: 18px">{{ Userinfo.serviceType }}</div>
								</div>
							</div>
						</div>

						<!-- ── QUICK SETTINGS ── -->
						<div class="section">
							<div class="section-head">
								<div class="section-title">Quick Settings</div>
							</div>

							<div class="settings-block">
								<div class="setting-row" v-if="Userinfo.serviceType === 'Auto-booking'">
									<div class="setting-row-left">
										<div class="setting-row-icon sr-blue">⚡</div>
										<div>
											<div class="setting-row-name">Auto-booking</div>
											<div class="setting-row-sub">Book slots automatically</div>
										</div>
									</div>
									<el-switch :disabled="orderStatus !== 'Active' && orderStatus !== 'Pause'" v-model="switch1" active-color="#2563eb" inactive-color="#d1d5db" active-value="1" inactive-value="0" @change="setupdateStatus(2)" />
								</div>

								<div class="setting-row" v-if="Userinfo.serviceType === 'Auto-booking' || Userinfo.serviceType === 'Notification'">
									<div class="setting-row-left">
										<div class="setting-row-icon sr-green">🔔</div>
										<div>
											<div class="setting-row-name">Notifications</div>
											<div class="setting-row-sub">SMS &amp; email alerts</div>
										</div>
									</div>
									<el-switch :disabled="orderStatus !== 'Active' && orderStatus !== 'Pause'" v-model="switch2" active-color="#2563eb" inactive-color="#d1d5db" active-value="1" inactive-value="0" @change="setupdateStatus(3)" />
								</div>
							</div>
						</div>
					</div>
					<!-- /panel-right -->
				</div>
				<!-- /body -->
			</div>
		</main>
	</div>
</template>
<script>
import { dashboardhistoryList, dashboardupdateStatus, opendashboard } from '@/api/home';
import { removeToken } from '@/utils/auth';

export default {
	components: {},
	data() {
		return {
			historyList: [],
			Userinfo: {
				orderStatus: '',
				appointmentslist: [],
			},
			orderStatus: '',
			switch1: '0',
			switch2: '0',
		};
	},
	computed: {
		avatarInitials() {
			const name = this.Userinfo.orderNo || '';
			return name.slice(-2).toUpperCase();
		},
	},
	created() {
		const cachedUserinfo = this.$store.getters.getUserinfo || {};
		const currentOrderNo = this.$store.state.orderNo;
		if (cachedUserinfo.orderNo && cachedUserinfo.orderNo !== currentOrderNo) {
			this.$store.commit('setUserinfo', {});
			this.Userinfo = { appointmentslist: [] };
		} else {
			this.Userinfo = cachedUserinfo;
			if (this.Userinfo.appointments) {
				const a = this.Userinfo.appointments.split('\n');
				const b = [];
				a.forEach((item) => b.push(item.split(',')[0]));
				this.Userinfo.appointmentslist = b;
			} else {
				this.Userinfo.appointmentslist = [];
			}
		}

		if (this.Userinfo.orderStatus === 'Cancelled') {
			this.orderStatus = 'Cancelled';
		} else {
			this.orderStatus = this.Userinfo.orderStatus;
		}
		this.getUserinfo();
	},
	methods: {
		handleCommand() {
			this.$store.commit('setOrderNo', '');
			this.$store.commit('setUserinfo', {});
			removeToken();
			this.$router.push('/login');
		},

		setupdateStatus(e) {
			if (this.orderStatus === 'Active' || this.orderStatus === 'Pause') {
				const that = this;
				let status = '';
				let params = {};

				if (e) {
					status = e === 2 ? (this.switch1 === '1' ? '1' : '0') : this.switch2 === '1' ? '1' : '0';
					params = { orderNo: this.Userinfo.orderNo, status, type: e };
				} else {
					status = this.orderStatus === 'Active' ? 'Pause' : 'Active';
					params = { orderNo: this.Userinfo.orderNo, status, type: 1 };
				}

				dashboardupdateStatus(params)
					.then((res) => {
						if (res.data.code === 0) {
							that.$message({ message: 'Successfully updated', type: 'success' });
							that.getUserinfo();
						}
					})
					.catch(() => {
						that.$message({ message: 'Update failed', type: 'warning' });
					});
			} else {
				this.$message({ message: 'Cannot update in current status', type: 'warning' });
			}
		},

		getUserinfo() {
			const that = this;
			opendashboard({ orderNo: this.$store.state.orderNo })
				.then((res) => {
					that.$store.commit('setUserinfo', res.data.data);
					that.Userinfo = res.data.data;
					that.orderStatus = res.data.data.orderStatus;
					that.switch1 = res.data.data.isActive;
					that.switch2 = res.data.data.isNotice;
					that.getmeg();
				})
				.catch(() => {
					// that.$message({ message: 'Order error', type: 'warning' });
				});
		},

		getmeg() {
			const that = this;
			dashboardhistoryList({
				orderNo: that.Userinfo.orderNo,
				notificationType: '',
				pageNum: 1,
				pageSize: 4,
			})
				.then((res) => {
					res.data.rows.forEach((item) => {
						if (item.notificationType === 'success' && item.region) {
							if (item.region.indexOf('This slot has already been taken.') !== -1) {
								item.region1 = item.region.split('.')[0] + '.';
								item.region2 = item.region.split('.')[1] + '.';
								item.isregion = 1;
							} else if (item.region.indexOf("please don't take any action.") !== -1) {
								item.region1 = item.region.split('…')[0] + '…';
								item.region2 = item.region.split('…')[1];
								item.isregion = 2;
							} else {
								item.region1 = item.region;
							}
						}
					});
					that.historyList = res.data.rows;
				})
				.catch(() => {
					if (that.Userinfo.orderNo !== undefined) {
						that.$message({ message: 'Failed to load history', type: 'warning' });
					}
				});
		},
	},
};
</script>
<style scoped>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.page {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	background-color: #f9fafb;
	color: #111827;
	line-height: 1.6;
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

/* Sidebar */
.sidebar {
	position: fixed;
	left: 0;
	top: 0;
	width: 280px;
	height: 100vh;
	background: white;
	border-right: 1px solid #e5e7eb;
	display: flex;
	flex-direction: column;
	z-index: 1000;
	transition: transform 0.3s ease;
}

.sidebar-header {
	padding: 24px;
	border-bottom: 1px solid #e5e7eb;
}

.logo {
	display: flex;
	align-items: center;
	gap: 12px;
	font-size: 24px;
	font-weight: 700;
	color: #4f46e5;
}

.logo-icon {
	width: 40px;
	height: 40px;
	background: linear-gradient(135deg, #4f46e5, #6366f1);
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 24px;
}

.nav-menu {
	flex: 1;
	padding: 16px;
	overflow-y: auto;
}

.nav-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	margin-bottom: 4px;
	border-radius: 10px;
	color: #374151;
	text-decoration: none;
	transition: all 0.2s ease;
	cursor: pointer;
}

.nav-item:hover {
	background: #f3f4f6;
	color: #4f46e5;
}

.nav-item.active {
	background: #4f46e5;
	color: white;
}

.nav-icon {
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Main Content */
.main-content {
	margin-left: 270px;
	min-height: 100vh;
	background: #f9fafb;
}

/* Topbar */
.topbar {
	background: white;
	padding: 16px 32px;
	border-bottom: 1px solid #e5e7eb;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: sticky;
	top: 0;
	z-index: 100;
}

.topbar-left {
	display: flex;
	align-items: center;
	gap: 24px;
}

.menu-toggle {
	display: none;
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: #374151;
}

.page-title {
	font-size: 24px;
	font-weight: 600;
	color: #111827;
}

.topbar-right {
	display: flex;
	align-items: center;
	gap: 16px;
}

.notification-btn {
	position: relative;
	background: none;
	border: none;
	padding: 8px;
	cursor: pointer;
	color: #4b5563;
	transition: color 0.2s ease;
}

.notification-btn:hover {
	color: #4f46e5;
}

.notification-badge {
	position: absolute;
	top: 4px;
	right: 4px;
	width: 8px;
	height: 8px;
	background: #ef4444;
	border-radius: 50%;
}

.user-menu {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 16px;
	border-radius: 10px;
	cursor: pointer;
	transition: background 0.2s ease;
}

.user-menu:hover {
	background: #f3f4f6;
}

.user-avatar {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background: linear-gradient(135deg, #4f46e5, #ec4899);
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: 600;
}

/* Content */
.content {
	padding: 32px;
}

/* ── RESET & BASE ───────────────────────────────────────────── */
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

.dashboard {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	background: #f0f2f5;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	-webkit-font-smoothing: antialiased;
}

/* ── META BAR ───────────────────────────────────────────────── */
.meta-bar {
	background: #0b1d3a;
	border-bottom: 1px solid rgba(255, 255, 255, 0.07);
	padding: 0 32px;
	height: 52px;
	flex-shrink: 0;
}
.meta-bar-inner {
	max-width: 1400px;
	margin: 0 auto;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.meta-logo {
	display: flex;
	align-items: center;
	gap: 8px;
}
.meta-logo-dot {
	width: 8px;
	height: 8px;
	background: #2563eb;
	border-radius: 50%;
}
.meta-logo-name {
	font-size: 15px;
	color: rgba(255, 255, 255, 0.6);
	font-weight: 400;
	letter-spacing: 0.2px;
}
.meta-logo-name b {
	color: #fff;
	font-weight: 700;
}
.meta-right {
	display: flex;
	align-items: center;
	gap: 20px;
}
.meta-order {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
.meta-order-label {
	font-size: 10px;
	color: rgba(255, 255, 255, 0.35);
	text-transform: uppercase;
	letter-spacing: 0.06em;
}
.meta-order-val {
	font-size: 13px;
	color: rgba(255, 255, 255, 0.8);
	font-weight: 500;
}
.meta-divider {
	width: 1px;
	height: 20px;
	background: rgba(255, 255, 255, 0.1);
}
.meta-user {
	display: flex;
	align-items: center;
	gap: 9px;
	cursor: pointer;
	padding: 4px 8px;
	border-radius: 8px;
	transition: background 0.15s;
}
.meta-user:hover {
	background: rgba(255, 255, 255, 0.05);
}
.meta-user-avatar {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #2563eb;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	font-weight: 700;
	color: #fff;
}
.meta-user-type {
	font-size: 13px;
	color: rgba(255, 255, 255, 0.65);
}

/* ── BODY ───────────────────────────────────────────────────── */
.body {
	flex: 1;
	display: grid;
	grid-template-columns: 1fr 360px;
	gap: 24px;
	padding: 28px 32px;
	max-width: 1400px;
	margin: 0 auto;
	width: 100%;
}

/* ── SECTIONS ───────────────────────────────────────────────── */
.section {
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 16px;
	overflow: hidden;
}
.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 22px 14px;
	border-bottom: 1px solid #f3f4f6;
}
.section-title {
	font-size: 14px;
	font-weight: 600;
	color: #0b1d3a;
	letter-spacing: -0.1px;
}
.link-btn {
	background: none;
	border: none;
	font-size: 13px;
	color: #2563eb;
	font-weight: 500;
	cursor: pointer;
	padding: 0;
}
.link-btn:hover {
	text-decoration: underline;
}

/* ── STATUS HERO ────────────────────────────────────────────── */
.status-hero {
	border-radius: 16px;
	border: 1px solid #e5e7eb;
	overflow: hidden;
	margin-bottom: 20px;
	background: #fff;
}

/* hero top */
.hero-top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 22px 24px 16px;
	border-bottom: 1px solid #f3f4f6;
}
.hero-status-row {
	display: flex;
	align-items: center;
	gap: 14px;
}

.hero-label {
	font-size: 11px;
	color: #9ca3af;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	margin-bottom: 4px;
}
.hero-status-text {
	font-size: 26px;
	font-weight: 800;
	letter-spacing: -0.5px;
	line-height: 1;
}
.txt-active {
	color: #2563eb;
}
.txt-success {
	color: #10b981;
}
.txt-error {
	color: #ef4444;
}
.txt-pause {
	color: #f59e0b;
}
.txt-cancelled {
	color: #9ca3af;
}

/* indicator circle */
.hero-indicator {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	font-size: 18px;
	font-weight: 700;
}
.ind-active {
	background: #dbeafe;
	color: #2563eb;
}
.ind-success {
	background: #d1fae5;
	color: #10b981;
}
.ind-error {
	background: #fee2e2;
	color: #ef4444;
}
.ind-pause {
	background: #fef3c7;
	color: #f59e0b;
}
.ind-cancelled {
	background: #f3f4f6;
	color: #6b7280;
}
.ind-icon {
	font-size: 22px;
	line-height: 1;
}

/* spinning ring for active */
.spin-ring {
	display: inline-block;
	width: 22px;
	height: 22px;
	border: 3px solid rgba(37, 99, 235, 0.25);
	border-top-color: #2563eb;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}
@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

/* badge pill */
.hero-badge {
	border-radius: 100px;
	padding: 5px 14px;
	font-size: 12px;
	font-weight: 600;
}
.badge-active {
	background: #dbeafe;
	color: #1d4ed8;
}
.badge-success {
	background: #d1fae5;
	color: #065f46;
}
.badge-error {
	background: #fee2e2;
	color: #991b1b;
}
.badge-pause {
	background: #fef3c7;
	color: #92400e;
}
.badge-cancelled {
	background: #f3f4f6;
	color: #6b7280;
}

/* hero body */
.hero-body {
	padding: 24px;
}

/* Active state — pulse graphic */
.hero-searching {
	display: flex;
	align-items: center;
	gap: 28px;
}
.search-pulse {
	position: relative;
	width: 80px;
	height: 80px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.pulse-ring {
	position: absolute;
	border-radius: 50%;
	border: 1.5px solid rgba(37, 99, 235, 0.3);
	animation: pRing 2.4s ease-in-out infinite;
}
.r1 {
	width: 36px;
	height: 36px;
	animation-delay: 0s;
}
.r2 {
	width: 58px;
	height: 58px;
	animation-delay: 0.4s;
}
.r3 {
	width: 80px;
	height: 80px;
	animation-delay: 0.8s;
}
@keyframes pRing {
	0%,
	100% {
		opacity: 0.6;
	}
	50% {
		opacity: 0.1;
	}
}
.pulse-core {
	font-size: 22px;
	position: relative;
	z-index: 1;
}

.search-title {
	font-size: 17px;
	font-weight: 700;
	color: #0b1d3a;
	margin-bottom: 4px;
}
.search-sub {
	font-size: 13px;
	color: #6b7280;
	margin-bottom: 10px;
}
.search-range {
	display: inline-block;
	background: #eff6ff;
	border: 1px solid #bfdbfe;
	color: #1d4ed8;
	border-radius: 8px;
	padding: 4px 12px;
	font-size: 13px;
	font-weight: 500;
}

/* Success grid */
.hero-success-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
}
.sg-item {
	background: #f8fafc;
	border: 1px solid #e5e7eb;
	border-radius: 10px;
	padding: 14px 16px;
}
.sg-label {
	font-size: 10px;
	color: #9ca3af;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	margin-bottom: 5px;
}
.sg-val {
	font-size: 15px;
	font-weight: 600;
	color: #0b1d3a;
}

/* Error */
.hero-error-box {
	background: #fef2f2;
	border: 1px solid #fecaca;
	border-radius: 12px;
	padding: 18px 20px;
}
.error-title {
	font-size: 14px;
	font-weight: 700;
	color: #991b1b;
	margin-bottom: 6px;
}
.error-desc {
	font-size: 13px;
	color: #b91c1c;
	margin-bottom: 8px;
	line-height: 1.6;
}
.error-hint {
	font-size: 12px;
	color: #9ca3af;
}

/* Paused */
.hero-paused {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 12px 0;
	text-align: center;
}
.paused-icon {
	font-size: 36px;
	margin-bottom: 10px;
}
.paused-title {
	font-size: 17px;
	font-weight: 700;
	color: #0b1d3a;
	margin-bottom: 4px;
}
.paused-sub {
	font-size: 13px;
	color: #6b7280;
}

/* Cancelled */
.hero-cancelled {
	text-align: center;
	padding: 12px 0;
}
.cancelled-title {
	font-size: 17px;
	font-weight: 700;
	color: #374151;
	margin-bottom: 6px;
}
.cancelled-sub {
	font-size: 13px;
	color: #9ca3af;
}

/* hero action */
.hero-action {
	padding: 0 24px 22px;
}
.action-btn {
	width: 100%;
	padding: 13px;
	border-radius: 10px;
	font-size: 14px;
	font-weight: 600;
	border: none;
	cursor: pointer;
	transition: all 0.18s;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	font-family: inherit;
}
.action-btn--pause {
	background: #0b1d3a;
	color: #fff;
}
.action-btn--pause:hover {
	background: #1e3a6e;
	transform: translateY(-1px);
}
.action-btn--play {
	background: #2563eb;
	color: #fff;
}
.action-btn--play:hover {
	background: #1d4ed8;
	transform: translateY(-1px);
}
.action-btn--disabled {
	background: #f3f4f6;
	color: #9ca3af;
	cursor: default;
}

/* ── TIMELINE ACTIVITY ──────────────────────────────────────── */
.timeline {
	padding: 20px 22px;
	display: flex;
	flex-direction: column;
	gap: 0;
}
.tl-item {
	display: flex;
	align-items: flex-start;
	gap: 14px;
	padding-bottom: 20px;
	position: relative;
}
.tl-item:not(:last-child)::before {
	content: '';
	position: absolute;
	left: 5px;
	top: 16px;
	bottom: 0;
	width: 1px;
	background: #f3f4f6;
}
.tl-dot {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	flex-shrink: 0;
	margin-top: 4px;
}
.tl-blue {
	background: #2563eb;
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}
.tl-green {
	background: #10b981;
	box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
}
.tl-amber {
	background: #f59e0b;
	box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);
}
.tl-red {
	background: #ef4444;
	box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
}
.tl-content {
	flex: 1;
	min-width: 0;
}
.tl-title {
	font-size: 13.5px;
	font-weight: 600;
	color: #111827;
	margin-bottom: 3px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.tl-time {
	font-size: 12px;
	color: #9ca3af;
	line-height: 1.5;
}
.tl-empty {
	font-size: 13px;
	color: #9ca3af;
	text-align: center;
	padding: 20px 0;
}

/* ── RIGHT PANEL ────────────────────────────────────────────── */
.panel-right {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

/* INFO STACK */
.info-stack {
	display: flex;
	flex-direction: column;
	gap: 12px;
}
.info-card {
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 14px;
	padding: 18px 20px;
	display: flex;
	align-items: flex-start;
	gap: 14px;
}
.info-card-icon {
	width: 40px;
	height: 40px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	flex-shrink: 0;
}
.ic-blue {
	background: #dbeafe;
}
.ic-amber {
	background: #fef3c7;
}
.ic-purple {
	background: #ede9fe;
}
.info-card-body {
	flex: 1;
	min-width: 0;
}
.info-card-label {
	font-size: 10px;
	color: #9ca3af;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	margin-bottom: 4px;
}
.info-card-val {
	font-size: 24px;
	font-weight: 800;
	color: #0b1d3a;
	letter-spacing: -0.5px;
	line-height: 1;
	margin-bottom: 5px;
}
.info-card-sub {
	font-size: 12px;
	color: #6b7280;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.change-plan-btn {
	margin-top: 8px;
	background: #2563eb;
	color: #fff;
	border: none;
	border-radius: 7px;
	padding: 6px 14px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	font-family: inherit;
	transition: background 0.15s;
}
.change-plan-btn:hover {
	background: #1d4ed8;
}

/* SETTINGS BLOCK */
.settings-block {
	padding: 8px 0;
	display: flex;
	flex-direction: column;
}
.setting-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 22px;
	border-bottom: 1px solid #f9fafb;
	transition: background 0.15s;
}
.setting-row:last-child {
	border-bottom: none;
}
.setting-row:hover {
	background: #fafafa;
}
.setting-row-left {
	display: flex;
	align-items: center;
	gap: 12px;
}
.setting-row-icon {
	width: 34px;
	height: 34px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	flex-shrink: 0;
}
.sr-blue {
	background: #dbeafe;
}
.sr-green {
	background: #d1fae5;
}
.setting-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #111827;
}
.setting-row-sub {
	font-size: 12px;
	color: #9ca3af;
	margin-top: 1px;
}

/* ── RESPONSIVE ─────────────────────────────────────────────── */
@media (max-width: 1100px) {
	.body {
		grid-template-columns: 1fr;
		max-width: 720px;
	}
	.panel-right {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 16px;
	}
	.info-stack {
		grid-column: 1 / -1;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (max-width: 700px) {
	.body {
		padding: 16px;
		gap: 16px;
	}
	.hero-success-grid {
		grid-template-columns: 1fr;
	}
	.panel-right {
		grid-template-columns: 1fr;
	}
	.info-stack {
		grid-template-columns: 1fr;
	}
	.meta-bar {
		padding: 0 16px;
	}
	.meta-order {
		display: none;
	}
}
</style>
